import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Select from '../form/Select'
import { getQuotaOptions } from '../../Models/SkipLogicHelpers'

@observer
class SkipDateOption extends Component {
    quotaOptions = getQuotaOptions()

    updateOperator = (obj) => {
        const { group, triggerIndex } = this.props
        const { condition } = group.triggers[triggerIndex]

        condition.equalityOperator = obj.value
    }

    render() {
        const { group, triggerIndex, store } = this.props
        const { condition } = group.triggers[triggerIndex]
        const { dateField, equalityOperator } = condition

        return (
            <div className={`skip-date-option-wrapper ${triggerIndex === 0 ? 'option-wrapper-border-radius' : ''}`}>
                <div style={{ flex: 1 }}>
                    <Select
                        label={i18n.t('skipLogicModal.pageLogicRuleDate')}
                        cssClass="skipLogicDropdown"
                        defaultValue={this.quotaOptions
                            .find(({ value }) => value === equalityOperator).value}
                        onBlur={this.updateOperator}
                        options={this.quotaOptions}
                    />
                </div>

                <br />

                <div className="skip-date-option-label">
                    {i18n.t(`s_skiplogic_${dateField}`)}

                    <i
                        className="fal fa-times-circle deleteicon left"
                        onClick={(e) => {
                            group.removeTrigger(triggerIndex, e)
                            store.handleUnsavedSkipLogicChanges()
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default SkipDateOption
